// @flow

import React, { type Node } from 'react';
import { TipsBox } from '../../../../organisms/tips-box';

import smartphonePayment from './smartphone-payment.svg';
import smartphoneCopy from './smartphone-copy.svg';
import bankUser from './bank-user.svg';
import smartphoneCheck from './smartphone-check.svg';
import { usePendingIncomingPayment } from '@tectonics/prs/incoming-payment';

export function PaymentInstructions(): Node {
  const incomingPayment = usePendingIncomingPayment();
  return (
    <TipsBox title="Instrucciones de pago" tipsModel={[
      {
        imgSrc: smartphonePayment,
        altText: 'smartphone payment icon',
        tipText: `
          Acceda a su aplicación bancaria e 
          ingrese a la opción de Transferencia Bancaria
        `,
      },
      {
        imgSrc: smartphoneCopy,
        altText: 'smartphone copy icon',
        tipText: `
          Para garantizar su pago, digite el número
          de referencia y el total a pagar tal 
          como aparece en su factura.
        `,
      },
      {
        imgSrc: bankUser,
        altText: 'bank-user icon',
        tipText: `
          Identifica como beneficiario a EBANX ${incomingPayment.country == 'pe' ? 'PERU SAC' : ''}
        `,
      },
      {
        imgSrc: smartphoneCheck,
        altText: 'smartphone check icon',
        tipText: `
          Confirma los datos y realiza la transferencia bancária.
        `,
      },
    ]} />

  );
}
